import React from 'react'
import { Box, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import {
  FaFolderOpen,
  FaGlobe,
  FaList,
  FaMusic,
  FaSearch,
  FaTh,
  FaUsers,
} from 'react-icons/fa'

const GESTION_NAV = [
  { label: 'Archivo Musical', color: 'purple.500', tint: 'purple.50' },
  { label: 'Mis músicos', color: 'green.500', tint: 'green.50' },
  { label: 'Formaciones', color: 'orange.500', tint: 'orange.50' },
  { label: 'Actuaciones', color: 'blue.500', tint: 'blue.50' },
  { label: 'Ensayos', color: 'pink.500', tint: 'pink.50' },
]

const MUSICOS = [
  { ini: 'AR', name: 'Ana Ruiz', inst: 'Clarinete · 1ª', on: true },
  { ini: 'LM', name: 'Luis Mora', inst: 'Trompeta · 2ª', on: true },
  { ini: 'MG', name: 'Marta Gil', inst: 'Tuba', on: true },
  { ini: 'PD', name: 'Pablo Díaz', inst: 'Percusión', on: false },
]

const OBRAS = [
  { title: 'Cristo de la Salud', meta: 'Marcha · 12 voces' },
  { title: 'Virgen de la Paloma', meta: 'Marcha · 8 voces' },
  { title: 'Amargura', meta: 'Marcha · 10 voces' },
]

const Pill = ({ active, children, icon: IconCmp }) => (
  <HStack
    gap={1.5}
    px={2.5}
    py={1}
    rounded="full"
    bg={active ? 'purple.600' : 'transparent'}
    color={active ? 'white' : 'gray.700'}
    fontSize="2xs"
    fontWeight="700"
  >
    {IconCmp ? <Box as={IconCmp} boxSize={2.5} /> : null}
    <Text as="span">{children}</Text>
  </HStack>
)

const AppHeader = ({ tab }) => (
  <Flex
    bg="white"
    borderBottomWidth="1px"
    borderColor="gray.200"
    minH="44px"
    px={3}
    align="center"
    justify="space-between"
    gap={2}
  >
    <Box
      as="img"
      src="/logo y texto cadencya.png"
      alt=""
      h="26px"
      w="auto"
    />
    <HStack gap={0.5} display={{ base: 'none', sm: 'flex' }}>
      <Pill icon={FaSearch}>Comunidad</Pill>
      <Pill active={tab === 'gestion'} icon={FaFolderOpen}>Gestión</Pill>
      <Pill active={tab === 'tuweb'} icon={FaGlobe}>Tu web</Pill>
    </HStack>
    <Box w={6} h={6} rounded="full" bg="purple.100" flexShrink={0} />
  </Flex>
)

const Breadcrumbs = ({ items }) => (
  <Flex
    bg="white"
    borderBottomWidth="1px"
    borderColor="gray.200"
    h="32px"
    px={4}
    align="center"
    gap={1.5}
    fontSize="2xs"
  >
    {items.map((item, i) => (
      <HStack key={item} gap={1.5}>
        {i > 0 ? (
          <Text color="gray.300" fontWeight="600">
            /
          </Text>
        ) : null}
        <Text color={i === items.length - 1 ? 'purple.600' : 'gray.600'} fontWeight={i === items.length - 1 ? '600' : '400'}>
          {item}
        </Text>
      </HStack>
    ))}
  </Flex>
)

const GestionSidebar = ({ active }) => (
  <Box
    display={{ base: 'none', md: 'block' }}
    w="148px"
    flexShrink={0}
    borderRightWidth="1px"
    borderColor="gray.200"
    bg="white"
    py={3}
    px={1.5}
  >
    <Text
      fontSize="2xs"
      fontWeight="700"
      color="gray.400"
      px={2}
      mb={2}
      textTransform="uppercase"
      letterSpacing="widest"
    >
      Gestión
    </Text>
    <VStack gap={0.5} align="stretch">
      {GESTION_NAV.map((item) => {
        const isActive = item.label === active
        return (
          <HStack
            key={item.label}
            gap={2}
            px={2}
            py={1.5}
            rounded="lg"
            bg={isActive ? 'purple.600' : 'transparent'}
            color={isActive ? 'white' : 'gray.700'}
          >
            <Box
              p={1}
              rounded="sm"
              bg={isActive ? 'whiteAlpha.300' : item.tint}
              flexShrink={0}
            >
              <Box w={2} h={2} rounded="sm" bg={isActive ? 'white' : item.color} />
            </Box>
            <Text fontSize="2xs" fontWeight="700" lineHeight="1.2">
              {item.label}
            </Text>
          </HStack>
        )
      })}
    </VStack>
  </Box>
)

const MusicosBody = () => (
  <Box p={{ base: 3, md: 4 }} bg="gray.50" flex={1} minW={0}>
    <Box bg="white" rounded="xl" borderWidth="1px" borderColor="gray.100" overflow="hidden">
      <Flex px={3} pt={3} pb={2} justify="space-between" align="center">
        <Text fontSize="xs" fontWeight="800" color="gray.800">
          Mis músicos
        </Text>
        <HStack gap={1}>
          <Box px={2} py={0.5} rounded="md" bg="purple.600" color="white" fontSize="2xs" fontWeight="700">
            Plantilla
          </Box>
          <Box px={2} py={0.5} rounded="md" color="gray.500" fontSize="2xs" fontWeight="600">
            Grupos de músicos
          </Box>
        </HStack>
      </Flex>
      <HStack
        px={3}
        py={1.5}
        borderBottomWidth="1px"
        borderColor="gray.100"
        fontSize="2xs"
        color="gray.400"
        fontWeight="700"
      >
        <Box w={6} />
        <Text flex={1}>Nombre</Text>
        <Text flex={1} display={{ base: 'none', sm: 'block' }}>
          Instrumentos / voces
        </Text>
        <Text w="44px">Estado</Text>
      </HStack>
      {MUSICOS.map((m) => (
        <HStack
          key={m.ini}
          px={3}
          py={1.5}
          borderBottomWidth="1px"
          borderColor="gray.50"
          fontSize="2xs"
        >
          <Flex
            w={6}
            h={6}
            rounded="full"
            bg="purple.100"
            color="purple.700"
            align="center"
            justify="center"
            fontWeight="800"
            fontSize="2xs"
            flexShrink={0}
          >
            {m.ini}
          </Flex>
          <Text flex={1} fontWeight="700" color="gray.800" lineClamp={1}>
            {m.name}
          </Text>
          <Text flex={1} color="gray.500" display={{ base: 'none', sm: 'block' }} lineClamp={1}>
            {m.inst}
          </Text>
          <Box
            w="28px"
            h="16px"
            rounded="full"
            bg={m.on ? 'green.400' : 'gray.200'}
            position="relative"
            flexShrink={0}
          >
            <Box
              position="absolute"
              top="2px"
              left={m.on ? '14px' : '2px'}
              w="12px"
              h="12px"
              rounded="full"
              bg="white"
            />
          </Box>
        </HStack>
      ))}
    </Box>
  </Box>
)

const ArchivoBody = () => (
  <Box p={{ base: 3, md: 4 }} bg="gray.50" flex={1} minW={0}>
    <Box bg="white" rounded="xl" borderWidth="1px" borderColor="gray.100" p={3}>
      <Flex justify="space-between" align="center" mb={3}>
        <Text fontSize="xs" fontWeight="800" color="gray.800">
          Archivo Musical
        </Text>
        <HStack gap={1} color="gray.400">
          <Box as={FaList} boxSize={3} />
          <Box as={FaTh} boxSize={3} color="purple.600" />
        </HStack>
      </Flex>
      <HStack
        mb={3}
        px={2.5}
        py={1.5}
        rounded="md"
        bg="gray.50"
        borderWidth="1px"
        borderColor="gray.200"
        color="gray.400"
        fontSize="2xs"
        gap={2}
      >
        <Box as={FaSearch} boxSize={2.5} />
        <Text>Buscar obra o carpeta…</Text>
      </HStack>
      <HStack gap={1.5} mb={3}>
        <Box px={2} py={0.5} rounded="md" bg="purple.50" color="purple.700" fontSize="2xs" fontWeight="700">
          Procesiones
        </Box>
        <Box px={2} py={0.5} rounded="md" bg="gray.100" color="gray.600" fontSize="2xs" fontWeight="600">
          Conciertos
        </Box>
      </HStack>
      <HStack gap={2} align="stretch">
        {OBRAS.map((obra) => (
          <VStack
            key={obra.title}
            flex={1}
            align="stretch"
            gap={1.5}
            minW={0}
          >
            <Flex
              h={{ base: '52px', md: '64px' }}
              rounded="md"
              bg="purple.50"
              borderWidth="1px"
              borderColor="purple.100"
              align="center"
              justify="center"
            >
              <Box as={FaMusic} boxSize={3.5} color="purple.400" />
            </Flex>
            <Text fontSize="2xs" fontWeight="700" color="gray.800" lineClamp={1}>
              {obra.title}
            </Text>
            <Text fontSize="2xs" color="gray.500" lineClamp={1}>
              {obra.meta}
            </Text>
          </VStack>
        ))}
      </HStack>
    </Box>
  </Box>
)

const MicrositePublicShot = () => (
  <Box bg="#1a202c" minH={{ base: '240px', md: '300px' }}>
    <Flex
      px={4}
      py={2}
      align="center"
      justify="space-between"
      borderBottomWidth="1px"
      borderColor="whiteAlpha.200"
    >
      <Text color="white" fontSize="2xs" fontWeight="800">
        Agrupación Musical
      </Text>
      <HStack gap={3} display={{ base: 'none', sm: 'flex' }} color="whiteAlpha.800" fontSize="2xs" fontWeight="600">
        <Text>Inicio</Text>
        <Text>Calendario</Text>
        <Text>Contacto</Text>
      </HStack>
    </Flex>
    <Flex
      direction="column"
      align="center"
      justify="center"
      py={{ base: 8, md: 10 }}
      px={4}
      bgGradient="linear(to-b, #4c1d95, #1a202c)"
      gap={3}
    >
      <Flex
        w="48px"
        h="48px"
        rounded="full"
        bg="whiteAlpha.300"
        borderWidth="2px"
        borderColor="whiteAlpha.400"
        align="center"
        justify="center"
      >
        <Box as={FaUsers} boxSize={4} color="white" />
      </Flex>
      <Text color="white" fontWeight="900" fontSize="sm" letterSpacing="-0.02em" textAlign="center">
        Agrupación Musical
      </Text>
      <HStack gap={2}>
        <Box px={2} py={0.5} rounded="full" bg="whiteAlpha.200" color="white" fontSize="2xs" fontWeight="600">
          Banda de música
        </Box>
      </HStack>
      <Box px={4} py={1.5} rounded="full" bg="white" color="gray.800" fontSize="2xs" fontWeight="800">
        Contáctanos
      </Box>
    </Flex>
  </Box>
)

const LandingProductShot = ({ variant = 'gestion' }) => {
  const isWebPublic = variant === 'web'
  const isArchivo = variant === 'archivo'

  return (
    <Box
      w="full"
      bg="white"
      rounded="2xl"
      borderWidth="1px"
      borderColor="gray.200"
      overflow="hidden"
      boxShadow="md"
      aria-hidden="true"
      pointerEvents="none"
      userSelect="none"
    >
      {isWebPublic ? (
        <MicrositePublicShot />
      ) : (
        <Box>
          <AppHeader tab="gestion" />
          <Breadcrumbs
            items={
              isArchivo
                ? ['Inicio', 'Gestión', 'Archivo Musical']
                : ['Inicio', 'Gestión', 'Mis músicos']
            }
          />
          <Flex minH={{ base: '220px', md: '268px' }} align="stretch">
            <GestionSidebar active={isArchivo ? 'Archivo Musical' : 'Mis músicos'} />
            {isArchivo ? <ArchivoBody /> : <MusicosBody />}
          </Flex>
        </Box>
      )}
    </Box>
  )
}

export default LandingProductShot
